import { getManualSmsWarning } from "../../utils/manualSms";

const ManualSmsLengthWarning = ({ message, options }) => {
  const warning = getManualSmsWarning(message, options);
  return warning ? (
    <p className="uk-text-meta uk-margin-small-top" role="status">
      {warning}
    </p>
  ) : null;
};

export default ManualSmsLengthWarning;
